export default __webpack_public_path__ + "static/barlow-v4-latin-300-c1ea000a0e3c35601a0109d979094819.svg";